"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtcProvider = void 0;
const protocol_1 = require("../../protocol");
const utils_1 = require("../../utils");
const InjectUtils_1 = require("../InjectUtils");
const media_1 = require("../../utils/media");
class BtcProvider {
    constructor() {
        this.accountChangedBtcHandler = null;
    }
    connect() {
        return window.okxwallet.unisat.connect();
    }
    switchChain(chain) {
        return __awaiter(this, void 0, void 0, function* () {
            let okxwallet = window.okxwallet.unisat;
            switch (chain) {
                case protocol_1.BTC_CHAINS.MAINNET:
                    yield okxwallet.switchChain('BITCOIN_MAINNET');
                    break;
                case protocol_1.BTC_CHAINS.FRACTAL:
                    yield okxwallet.switchChain('FRACTAL_BITCOIN_MAINNET');
                    break;
            }
        });
    }
    connectReady() {
        return true;
    }
    parseConnectResponse(needPop, accountChange, signalChain, connectWalletNameSpace, connectRequestWalletResponse) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let connectChain = [];
                connectWalletNameSpace.forEach(item => {
                    if (item.namespace === protocol_1.NameSpaceKeyBtc) {
                        connectChain.push(...item.chains);
                    }
                });
                let addresses = [];
                let extra = {};
                if (connectChain.length == 0) {
                    return undefined;
                }
                const findAddress = (addresses, chainStr) => {
                    return addresses.find((addressItem) => {
                        const matchCoin = (addressItem.name === 'bitcoin' && chainStr === protocol_1.BTC_CHAINS.MAINNET)
                            || (addressItem.name === 'fractalbitcoin' && chainStr === protocol_1.BTC_CHAINS.FRACTAL);
                        return (addressItem.coinType === 0 && matchCoin)
                            || (addressItem.namespaceChainId === chainStr);
                    });
                };
                const processChain = (chainStr) => __awaiter(this, void 0, void 0, function* () {
                    let selectedAddress = findAddress(connectRequestWalletResponse.address, chainStr);
                    if (!selectedAddress)
                        return;
                    addresses.push(chainStr + ":" + selectedAddress.address);
                    let accounts = yield this.connect();
                    extra[chainStr] = {
                        publicKey: accounts.publicKey,
                        compressedPublicKey: accounts.compressedPublicKey
                    };
                });
                const promises = connectChain.map(processChain);
                yield Promise.all(promises);
                if (addresses && addresses.length > 0) {
                    let nameSpaceResponse = {
                        namespace: protocol_1.NameSpaceKeyBtc,
                        addresses: addresses,
                        methods: [...InjectUtils_1.BtcMethods],
                        extra: extra
                    };
                    return nameSpaceResponse;
                }
                return undefined;
            }
            catch (error) {
                throw error;
            }
        });
    }
    restoreConnect() {
        return __awaiter(this, void 0, void 0, function* () {
            if ((0, media_1.isDevice)("mobile")) {
                return this.connect();
            }
            return Promise.resolve();
        });
    }
    send(request) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                (0, utils_1.logDebug)("btcProvider send request:", JSON.stringify(request));
                const method = request.method;
                const chain = request.chainId;
                yield this.restoreConnect();
                yield this.switchChain(chain);
                let result;
                if (request.params) {
                    switch (method) {
                        case "btc_signMessage": {
                            const { signStr, type } = (request.params || {});
                            const signature = yield window.okxwallet.unisat.signMessage(signStr, type);
                            return {
                                method: request.method,
                                result: signature,
                            };
                        }
                        case "btc_send": {
                            const { from, to, value, satBytes } = (request.params || {});
                            const hash = yield window.okxwallet.unisat.send({ from, to, value, satBytes });
                            return {
                                method: request.method,
                                result: hash,
                            };
                        }
                        case "btc_signPsbts": {
                            const { psbtHexs, options } = (request.params || {});
                            let signatures;
                            if (Array.isArray(psbtHexs) && psbtHexs.length === 1) {
                                let signature;
                                if (Array.isArray(options)) {
                                    signature = yield window.okxwallet.unisat.signPsbt(psbtHexs[0], options.length > 0 && typeof options[0] === "object" ? options[0] : undefined);
                                }
                                else {
                                    signature = yield window.okxwallet.unisat.signPsbt(psbtHexs[0]);
                                }
                                signatures = [signature];
                            }
                            else {
                                signatures = yield window.okxwallet.unisat.signPsbts(psbtHexs, options);
                            }
                            return {
                                method: request.method,
                                result: (0, utils_1.safeJsonStringify)(signatures),
                            };
                        }
                        case "btc_signAndPushPsbt": {
                            const { psbtHex, options } = (request.params || {});
                            const signedPsbt = yield window.okxwallet.unisat.signPsbt(psbtHex, options);
                            const hash = yield window.okxwallet.unisat.pushPsbt(signedPsbt);
                            return {
                                method: request.method,
                                result: (0, utils_1.safeJsonStringify)({
                                    signedPsbt: signedPsbt,
                                    txHash: hash
                                }),
                            };
                        }
                        case "btc_sendInscription": {
                            const { address, inscriptionId, options } = (request.injectParams || {});
                            const result = yield window.okxwallet.unisat.sendInscription(address, inscriptionId, options);
                            return {
                                method: request.method,
                                result: result,
                            };
                        }
                        case "btc_inscribeTransfer": {
                            if (this.hasFunction('inscribeTransfer')) {
                                const { ticker, amount } = (request.params || {});
                                const result = yield window.okxwallet.unisat.inscribeTransfer(ticker, amount);
                                return {
                                    method: request.method,
                                    result: result,
                                };
                            }
                        }
                        case 'btc_sendRunes': {
                            if (this.hasFunction('sendRunes')) {
                                const { address, runeid, amount, options } = (request.injectParams || {});
                                const result = yield window.okxwallet.unisat.sendRunes(address, runeid, amount, options);
                                return {
                                    method: request.method,
                                    result: result,
                                };
                            }
                        }
                        default:
                            throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED, `method: '${method}' not support`);
                    }
                }
                else {
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.BAD_REQUEST_ERROR, `param is error method: '${method}'`);
                }
            }
            catch (error) {
                (0, utils_1.logDebug)("BtcProvider send error:", error);
                throw error;
            }
        });
    }
    hasFunction(functionName) {
        if (window.okxwallet && window.okxwallet.unisat && typeof window.okxwallet.unisat[functionName] === 'function') {
            return true;
        }
        else {
            return false;
        }
    }
    singleConnect(itemNameSpace) {
        return __awaiter(this, void 0, void 0, function* () {
            if (itemNameSpace.chains.length == 1) {
                return this.connect();
            }
            return false;
        });
    }
    addListener(accountChangeListener) {
        this.accountChangedBtcHandler = (accounts) => {
            console.log("window.okxwallet btc:", Date.now(), "btc", accounts);
            if (accounts && accounts.length > 0) { //
                accountChangeListener();
            }
        };
        window.okxwallet.unisat.on('accountsChanged', this.accountChangedBtcHandler);
    }
    removeListener() {
        window.okxwallet.unisat.removeListener('accountsChanged', this.accountChangedBtcHandler);
    }
}
exports.BtcProvider = BtcProvider;
